import { loadLib } from '../../utils/utils';
import { Globals } from '../../globals/variables';
import { sendFormOnAir, eventAddLabels } from '../tracking/addDeclaratives';

export async function loadLibrariesWalmeric() {
	/* Carga del script con todas las librerias */
	loadLib('https://t.womtp.com/slider/c/delio-lm/dfi/init.js', Globals.idTag);

	eventAddLabels();

	sendFormOnAir('.wg-form_api');
}